import React from 'react';
import PropTypes from 'prop-types';
import ChevronDown from '../../themes/svg/chevronDown';
import ChevronUp from '../../themes/svg/chevronUp';

const TopLevelExpander = (props) => {
  if (!props.showExpander) return null;

  return (
    <div className="expander">
      {props.allExpanded ? (
        <button className="link" onClick={() => props.collapseAll()}>
          Collapse All <ChevronUp />{' '}
        </button>
      ) : (
        <button className="link" onClick={() => props.expandAll()}>
          Expand All <ChevronDown />
        </button>
      )}
    </div>
  );
};

TopLevelExpander.propTypes = {
  showExpander: PropTypes.bool.isRequired,
  allExpanded: PropTypes.bool.isRequired,
  collapseAll: PropTypes.func.isRequired,
  expandAll: PropTypes.func.isRequired,
};

export default TopLevelExpander;
